import { render, staticRenderFns } from "./issuable_move_dropdown.vue?vue&type=template&id=33388e61"
import script from "./issuable_move_dropdown.vue?vue&type=script&lang=js"
export * from "./issuable_move_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports